module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.regBox.show) ? _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "box-main"
  }, [_c('div', {
    staticClass: "header clearfix"
  }, [(!_vm.isLogin) ? _c('h2', [_vm._v(_vm._s(_vm.regBoxData.btnText))]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "h-list"
  }, [_c('h2', {
    class: {
      'active': _vm.hList[0]
    },
    on: {
      "click": _vm.passwordLoginHandle
    }
  }, [_vm._v("密码登录")]), _vm._v(" "), _c('h2', {
    class: {
      'active': _vm.hList[1]
    },
    on: {
      "click": _vm.codeLoginHandle
    }
  }, [_vm._v("短信登录")])]) : _vm._e(), _vm._v(" "), _c('i', {
    on: {
      "click": _vm.regBoxCloseHandle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "m-l"
  }, [_c('div', {
    staticClass: "shh-bg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-r"
  }, [(!_vm.regBoxData.regSuccess) ? _c('div', {
    staticClass: "enter-contain"
  }, [_c('ul', [_c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "maxlength": 11,
      "placeholder": "手机号",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.regBoxData.isCode) ? _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "maxlength": 6,
      "placeholder": "验证码",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "code",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.codeMsg))])]) : _vm._e(), _vm._v(" "), (_vm.regBoxData.isPassword) ? _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "maxlength": 20,
      "placeholder": "密码",
      "type": "password",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.applyHandle
    }
  }, [_vm._v(_vm._s(_vm._f("cpText")(_vm.regBoxData.btnText)))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-text clearfix"
  }, [_c('p', {
    staticClass: "info fl"
  }, [_vm._v(_vm._s(_vm.regBoxData.infoText) + "？点我"), _c('b', {
    on: {
      "click": _vm.regHandle
    }
  }, [_vm._v(_vm._s(_vm.regBoxData.ciText))])]), _vm._v(" "), _c('p', {
    staticClass: "fr"
  }, [_c('i', {
    on: {
      "click": _vm.forgetPwdHandle
    }
  }, [_vm._v("忘记密码")])])])]) : _vm._e(), _vm._v(" "), (_vm.regBoxData.regSuccess) ? _c('div', {
    staticClass: "reg-success"
  }, [_c('h2', [_vm._v("欢迎加入点点大家庭！")]), _vm._v(" "), _c('p', [_vm._v("扫描二维码下载点点APP,立即领取您的额度！")]), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  })]) : _vm._e()])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23108023"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/regbox/index.vue
// module id = 329
// module chunks = 1